const routes = [
   // 预览页
   {
    path: '/phonePreviewQp',
    name: 'phonePreviewQp',
    meta: {
      title: "教材预览",
      volcengine: true,
    },
    component: () => import('../pages/phonePreviewQp/index.vue'),
  },
]

export default routes
